import { Box, styled } from '@mui/material';

export const OperationContainer = styled(Box)`
  display: flex;
  gap: 12px;
`;
